<template lang="pug">
v-navigation-drawer.drawer(width="72" permanent app)
  v-list(class="drawer-list")
    v-list-item.pa-3
      NuxtLink.mt-12.logo(to="/patients")
        Logo(:height="38")

    v-list-item-group(class="drawer-icons")
      NavbarItem(v-for="item in menuItems" :key="item.icon" 
        :icon="item.icon" 
        :path="item.path" 
        :slug="item.slug"
        :patientListToggle="patientListToggle"
        :disabled="item.disabled"
        :dropdownMenu="item.dropdownMenu"
        :currentPath="currentPath" 
        @on:select="onSubMenuClick"
        @on:active="onClick(item)")
    v-list-item-avatar.avatar-container
      NavbarAvatar(:user="user")
</template>

<script setup lang="ts">
const emit = defineEmits(['on:active'])
const route = useRoute()
const patientListToggle = ref(false)
const subMenuItems = [
  {
    title: 'Révoquer mon accés',
    path: '',
    slug: 'revoke',
  },
  {
    title: 'À propos',
    path: 'https://epoca-sante.atlassian.net/servicedesk/customer/portal/3/topic/fd64d794-7c07-4edb-a3f1-468a91b7e582/article/2048458753',
  },
  {
    title: 'Glossaire',
    path: 'https://epoca-sante.atlassian.net/servicedesk/customer/portal/3/article/2478604354',
  },
  {
    title: 'Protocoles & Procédures',
    path: 'https://epoca-sante.atlassian.net/servicedesk/customer/portal/3/topic/7e6a3734-9ab6-47bb-84c5-4ad3993d45b7',
  },
  {
    title: 'Signalement & Besoins',
    path: 'https://epoca-sante.atlassian.net/servicedesk/customer/portal/3/group/-1',
  },
  {
    title: 'Aide & Urgence',
    path: 'https://epoca-sante.atlassian.net/servicedesk/customer/portal/3/topic/7e6a3734-9ab6-47bb-84c5-4ad3993d45b7/article/2048327688',
  },
  {
    title: 'Événement indésirable',
    path: 'https://docs.google.com/forms/d/e/1FAIpQLSfImNtozId90OrDRGUukFXqNMjP5cIO24Ej-jsLCMBBTQE-nA/viewform?pli=1',
  },
  {
    title: 'CGU',
    path: 'https://epoca-sante.atlassian.net/servicedesk/customer/portal/3/topic/fd64d794-7c07-4edb-a3f1-468a91b7e582/article/2061697029',
  },
]
const menuItems = [
  { icon: 'epoca:map', path: '/map', slug: 'map', disabled: false },
  { icon: 'epoca:patient', path: '/patients', slug: 'patients' },
  { icon: 'epoca:practitioner', path: '/practitioners', slug: 'practitioners', disabled: false },
  { icon: 'epoca:hospital', path: '/', slug: 'organization', disabled: true },
  { icon: 'epoca:magnifierMenu', path: '/search/patients', slug: 'search-patients' },
  { icon: 'epoca:camera', path: '/call/internal', slug: 'call-internal' },
  {
    icon: 'epoca:information',
    path: '/admin/organizations',
    slug: 'admin-organizations',
    dropdownMenu: subMenuItems,
  },
  { icon: 'epoca:settings', path: '/monitor', slug: 'monitor', disabled: true },
]

const props = defineProps({
  /**
   *  user that is connected
   */
  user: {
    type: Object,
    required: true,
  },
  /**
   *  current path
   */
  currentPath: {
    type: String,
    required: true,
  },
})

/**
 * Gets called when the user select the tab item.
 * @param {any} item This will send selected tab item.
 */
const onClick = (item: any) => {
  switch (item.slug) {
    case 'patients':
      const routerName = route?.name as string
      const splitRouterName = routerName?.split('-')
      /*if (splitRouterName[0] === 'patients') {
        patientListToggle.value = !patientListToggle.value
        window.postMessage(JSON.stringify({ eventType: 'toggle_patient_lists' }))

        if (!patientListToggle.value) {
          navigateTo(item.path)
        }*/
      //} else {
      navigateTo(item.path)
      // }
      break
    case 'map':
      if (route.params?.patientId) navigateTo(`${item.path}/${route.params?.patientId}/`)
      else navigateTo(item.path)
      break
    case 'admin-organizations':
      break
    case 'call-internal':
      navigateTo(item.path, {
        open: {
          target: '_blank',
        },
      })
      break
    default:
      navigateTo(item.path)
      break
  }
  emit('on:active', item)
}

const onPatientListToggle = (event: any) => {
  patientListToggle.value = event.detail.patientListState
}

onMounted(async () => {
  document.addEventListener('patient_list_toggle' as string, onPatientListToggle)
})

onUnmounted(() => {
  document.removeEventListener('patient_list_toggle' as string, onPatientListToggle)
})

const onSubMenuClick = (item: any) => {
  switch (item.slug) {
    case 'revoke':
      revokeMessage()
    default:
      openLink(item.path)
  }
}

const revokeMessage = async () => {
  const emailAddress: string = 'support@epoca.health'
  const ccEmailAddres: string = 'dpo@epoca.health'
  const subject: string =
    "Demande de révocation de compte suite à une compromission de mon moyen d'identification électronique"
  const body: string = `Madame, Monsieur,\nJe vous écris le présent mail pour vous informer de la compromission d’un de mes moyens d'identification électronique associés à mon compte dans l’application EIIS, développée par EPOCA.\nLe moyen d’identification électronique est celui qui concerne mon numéro de téléphone : [votre numéro de téléphone].\nJ’ai découvert la compromission lorsque [expliquez comment vous avez découvert la compromission, par exemple, une activité inhabituelle sur le compte, etc.].\nConformément aux CGU de la plateforme, je sollicite respectueusement la révocation immédiate de mon compte dans un délai de 15 jours afin de protéger mes informations personnelles ainsi que celles des patients sous ma prise en charge et de prévenir tout accès non autorisé à mon compte. Je comprends que cette mesure peut entraîner la suspension temporaire de mes services via ce moyen d’identification, mais qu’elle permet de garantir la sécurité de mon compte et de mes données, ainsi que celles concernant mes patients pris en charge. Je suis aussi conscient(e) que si j’ai une carte eCPS, l’usage de Pro Santé Connect est un moyen d’identification alternatif possible pour me connecter à l’application.\nJe suis prêt(e) à coopérer pleinement avec votre équipe pour faciliter le processus de révocation et de sécurisation de mon compte.\nVous pouvez me contacter à l'adresse e-mail [votre adresse e-mail] ou au numéro de téléphone [votre numéro de téléphone] pour toute information supplémentaire.\nCordialement,[NOM] [Prénom]`
  window.location.href = `mailto:${emailAddress}?cc=${ccEmailAddres}&subject=${subject}&body=${encodeURIComponent(body)}`
}

const openLink = (link: string) => {
  navigateTo(link, {
    external: true,
    open: {
      target: '_blank',
    },
  })
}
</script>

<style lang="stylus" scoped>
.drawer
  flex 0
  border none
  background-color var(--japanese-indigo, #194355) !important
  .drawer-list
    display flex
    flex-direction column
    height 100%
  .drawer-icons
    flex 1
    display flex
    flex-direction column
    justify-content center
  .navigation-item
    padding 0
    margin 12px 0
    position relative;
    min-height 48px
  .nav-btn
    display flex
    justify-content center
    align-items center
    padding 12px 20px
    overflow visible
    color var(--white, #FFFFFF) !important
    text-decoration none
    :deep() path
      fill var(--white, #FFFFFF)
    &::before
      content ''
      position absolute
      border-radius 50%
      width 48px
      height 48px
      top 50%
      left 50%
      transform translate(-50%, -50%) scale(0)
      transition transform .3s ease, opacity .3s ease
      background-color var(--yankees-blue, #103342)
      opacity 0
    &:hover::before
      transform translate(-50%, -50%) scale(1)
      opacity 1
  .active-item .nav-btn:hover::before
    display none
  .active-item
    padding-left 12px !important
  .active-item
    &.active-circle
      padding-left 0 !important
      .nav-btn
      &:before, &:after
        display none

    &:before, &:after
      content ''
      position absolute
      width 25px
      height 48px
    &:before
      top 48px
      right 0
      border-radius 0 16px 0 0
      box-shadow 0 -16px 0 0 var(--ghost-white, #F7F8FA)
    &:after
      bottom 48px
      left calc(100% - 25px)
      border-radius 0 0 16px 0
      box-shadow 0 16px 0 0 var(--ghost-white, #F7F8FA)
    .nav-btn
      background-color var(--ghost-white, #F7F8FA)
      border-radius 50% 0% 0% 50%
      padding-left 8px !important
      :deep() path
        fill var(--japanese-indigo, #194355)
      &:hover::before
        display: none
  .avatar-container
    overflow visible
    padding 0 12px
  .icon
    width 24px
    height 24px
</style>
